import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SystemInfo } from '../models/system-info';
import { SystemEnvService } from '../services/system-env.service';

@Injectable({
  providedIn: 'root'
})
export class SystemInfoResolver implements Resolve<SystemInfo> {

  constructor(private systemEnvService: SystemEnvService) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SystemInfo> {
    return this.systemEnvService.initSystemInfo().pipe(map(result => this.systemEnvService.systemInfo));
  }
}
